import MainCommissionApprovals from "../components/commission-approvals/main-commission-approvals";

function CommissionApprovals() {
  return (
    <div>
      <MainCommissionApprovals />
    </div>
  );
}

export default CommissionApprovals;
